import React from 'react';
import { X } from 'react-feather';

import { commaThousondSeperator } from '@shared/lib';
import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
  Label,
  SuccessfunbdAward,
} from '@shared/ui';

import { TRedeemRewardResponse } from '../../api';

type TModalProps = {
  open: boolean;
  data: TRedeemRewardResponse;
  setOpen: (open: boolean) => void;
};
export const Modal = ({ open, setOpen, data }: TModalProps) => {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className='h-fit max-w-[455px]'>
        <DialogHeader className='flex flex-row items-center justify-between border-b border-border px-5 h-[67px]'>
          <DialogTitle className='text-right text-text body-13-bold'>هدیه صندوق</DialogTitle>

          <DialogClose asChild>
            <button className='flex items-center justify-center h-7 w-7 rounded-lg hover:bg-hover'>
              <X size={24} strokeWidth={1} />
            </button>
          </DialogClose>
        </DialogHeader>

        <div className='flex flex-col gap-[10px] items-center justify-center p-[30px]'>
          <SuccessfunbdAward />

          <Label className='h5-bold'>
            هدیه صندوق با <span className='text-green-1'>موفقیت</span> به شما تعلق گرفت.
          </Label>

          <div className='w-full flex flex-col'>
            <div className='w-full flex flex-row justify-between border-y border-border px-2 py-5'>
              <p className='body-12-regular text-text'>صندوق</p>
              <p className='body-12-regular text-text'>{data?.title ?? '-'}</p>
            </div>

            <div className='flex flex-row justify-between border-b border-border px-2 py-5'>
              <p className='body-12-regular text-text'>ارزش</p>
              <p className='body-12-regular text-text'>
                {commaThousondSeperator(data?.amount)} ریال
              </p>
            </div>
          </div>

          <p className='body-12-regular text-icons'>
            * صندوق در اولین روز کاری بعدی در دارایی شما قابل مشاهده خواهد بود
          </p>

          <DialogClose asChild>
            <Button className='h-[60px] w-full mt-4 flex items-center justify-center'>
              متوجه شدم
            </Button>
          </DialogClose>
        </div>
      </DialogContent>
    </Dialog>
  );
};
